import React from 'react';

const MainSection = () => (
    <div style={{
        textAlign: 'center',
        color: 'white',
        position: 'absolute',
        width: '100%',
        bottom: '20px'
    }}>
        <h1>Próximamente</h1>
    </div>
);

export default MainSection;
